export type PasswordValidationStatus =
  | "valid"
  | "short"
  | "repeatPasswordNoMatch";

export function validatePassword(
  password: string,
  repeatPassword: string
): PasswordValidationStatus {
  if (password.length < 8) return "short";
  if (password !== repeatPassword) return "repeatPasswordNoMatch";
  return "valid";
}

const emailRegex = /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;
export const validateEmail = (email: string): boolean => emailRegex.test(email);
